import { FormFieldsConfig } from 'pages/components/Form/FormEntities';

const ProfessionalInfosConfig: FormFieldsConfig = {
  profession: {
    default: 'dentist_surgeon',
    constraints: ['required'],
    options: [
      {
        label: 'dentist_surgeon',
        value: 'dentist_surgeon',
      },
      {
        label: 'ophthalmologist',
        value: 'ophthalmologist',
      },
      {
        label: 'plastic_surgeon',
        value: 'plastic_surgeon',
      },
    ],
  },
  specialty: {
    default: '',
    options: [
      { label: 'general_dentist', value: 'general_dentist' },
      { label: 'endodontist', value: 'endodontist' },
      {
        label: 'maxillofacial_sugeon',
        value: 'maxillofacial_sugeon',
      },
      { label: 'orthodontist', value: 'orthodontist' },
      { label: 'periodontist', value: 'periodontist' },
      { label: 'pedodontist', value: 'pedodontist' },
    ],
  },

  iban: {
    default: '',
    constraints: [
      // 'required', 
      'iban'
    ],
  },
  professionalNumber: {
    constraints: ['required'],
  },
  companyName: {
    // constraints: ["required"],
  },
  companyNumber: {
    constraints: ['required'],
  },
};

export default ProfessionalInfosConfig;
